import type {$Fetch} from "nitropack";
import BaseRepository from "~/api/BaseRepository";

export const FileRepository = (client: $Fetch) => ({
    ...BaseRepository(client)('v2/files'),
});